import React from 'react'
import UserChip from '../../../../../chip/UserChip'
import { Typography } from '@mui/material'
import SectionCollapse from '../../../../../section/SectionCollapse'

const UsersInformation = ({ type, items = [] }) => {
  return (
    <SectionCollapse title={`${type} (#${items?.length})`}>
      { items.length > 0 ?
        <div className='grid grid-cols-4 gap-2'>
        { items.map((item, index) => (
          <UserChip
            key={index}
            id={item.id}
            code={item.code}
            name={`${item.firstName} ${item.lastName}`}
            photo={item.photo}
            className='mb-2'
          />))
        }
        </div>
        :
        <Typography className='text-muted-foreground opacity-50'>You don't have any {type} yet</Typography>
      }
    </SectionCollapse>
  )
}

export default UsersInformation